import { Badge, type BadgeProps } from "@/components/ui/badge";
import type { User } from "@/lib/api-types";

/** Map a user_status to a badge tone. DELETED/INACTIVE/SUSPENDED read as muted/danger. */
export function StatusBadge({ status }: { status: User["user_status"] }) {
  const tone: BadgeProps["tone"] =
    status === "ACTIVE" ? "success" : status === "DELETED" ? "danger" : "neutral";
  return <Badge tone={tone}>{status}</Badge>;
}

/** Map a role_id to a badge tone. SUPER_ADMIN highlighted with the brand tone. */
export function RoleBadge({ role }: { role: User["role_id"] }) {
  const tone: BadgeProps["tone"] = role === "SUPER_ADMIN" ? "brand" : "neutral";
  return <Badge tone={tone}>{role}</Badge>;
}

const PROFILE_FIELDS = [
  ["user_name", "name"],
  ["class_id", "class"],
  ["phone", "phone"],
  ["school_name", "school"],
] as const;

/** Onboarding completeness for students; other roles don't onboard. */
export function ProfileBadge({ user }: { user: User }) {
  if (user.role_id !== "STUDENT") return <span className="text-text-subtle">--</span>;
  const missing = PROFILE_FIELDS.filter(([f]) => !user[f]).map(([, label]) => label);
  if (missing.length === 0) return <Badge tone="success">Complete</Badge>;
  return (
    <Badge tone="danger" title={`Missing: ${missing.join(", ")}`}>
      {user.class_id ? `No ${missing.join(", ")}` : "Not onboarded"}
    </Badge>
  );
}
